import moment from 'moment';

export default (value: Date | null | undefined, format = 'LL') =>
  value ? moment(value).format(format) : '';

export const prevMonthDateFrom = (): string =>
  moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');

export const prevMonthDateTo = (): string =>
  moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
